module.exports = __webpack_public_path__ + "static/media/video.5893f4f1.webm";